// src/lib/managers/mail/types/const.ts

/**
 * AB#1621 — REPLI uniquement. Les limites réelles de l'analyse initiale (fenêtre rétrospective) sont
 * désormais pilotées par la licence (`initialAnalysis.byMail` / `byDay`). Ces constantes ne servent
 * plus que de garde-fou si la licence est indisponible au moment du calcul (cf. INVESTIGATION §5.0/§5.6).
 */
export const INITIAL_ANALYSIS_MAIL_COUNT = 300;
export const INITIAL_ANALYSIS_BY_DAY_DEFAULT = 15;

/**
 * Préfixes d'URL blacklistés : un lien dont l'URL commence par l'un d'eux est écarté de l'extraction.
 *
 * ⚠️ Doit rester IDENTIQUE à la liste du backend (`baseMail.utils.ts` `blackListedUrlStart`).
 */
export const blackListedUrlStart: string[] = [
    "#",
    "mailto:",
    "tel:",
    "http://",
    "https://cloud.letsignit.com/collect/bc/",
    "https://cloud.letsignit.com/collect/b/",
    "https://aka.ms/JoinTeamsMeeting",
    "https://aka.ms/LearnAboutSenderIdentification",
    "https://dialin.teams.microsoft.com",
    "https://go.microsoft.com/fwlink/",
    "https://itunes.apple.com/app/microsoft-teams/",
    "https://play.google.com/store/apps/details?id=com.microsoft.teams",
    "https://support.microsoft.com/fr-FR/security/protect-yourself-from-phishing",
    "https://privacy.microsoft.com/privacystatement",
    "https://dialin.teams.microsoft.com/usp/pstnconferencing",
    "https://teams.microsoft.com/l/chat/",
    "https://teams.microsoft.com/l/meetup-join/",
    "https://teams.microsoft.com/meetingOptions/",
];
